import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [
  { title: "menu_sidebar_management" },
  { title: "menu_sidebar_management_list_management" },
  { title: "menu_sidebar_management_list_management_model" }
];

const ModelListing = Loadable({
  loader: () => import("container/management/auto/model"),
  loading() {
    return <Loader />;
  }
});

export const modelRoutes: IRoute[] = [
  {
    path: "/management/model",
    element: <ModelListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
